import { createFileRoute } from "@tanstack/react-router";
import ProductForm from "../../pages/admin/ProductForm";

export const Route = createFileRoute("/admin/products/$id/edit")({
  component: ProductForm,
});
